import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { uuid } from '../../utils/uuid';


@Injectable()
export class ActivityService {

  public counter$ = new BehaviorSubject<number>(0);

  private ids: string[] = [];

  constructor() {}

  register(): string {
    const id = uuid();
    this.ids.push(id);
    this.counter$.next(this.ids.length);

    return id;
  }

  unregister(id: string) {
    const index = this.ids.indexOf(id);
    if (index === -1) {
      return;
    }
    this.ids.splice(index, 1);

    this.counter$.next(this.ids.length);
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/core/activity/activity.service.ts